import {AvatarMenuItem} from '@coolcolduk/ui-mui';
import {Box, Container, Toolbar} from '@mui/material';
import {User} from '@cp/model';
import NavBarLogo from './NavBarLogo';
import NavBarMobileMenu from './NavBarMobileMenu';

interface NavBarMobileProps {
  user: User;
  navItems: AvatarMenuItem[];
  userMenu: AvatarMenuItem[];
}

export default function NavBarMobile({user, navItems, userMenu}: NavBarMobileProps) {
  return (
    <Box data-testid="navbar-mobile" sx={{display: {xs: 'block', md: 'none'}}}>
      <Container maxWidth="lg">
        <Toolbar sx={{px: {xs: 0}}}>
          {/* Logo for mobile */}
          <NavBarLogo />

          <NavBarMobileMenu user={user} navItems={navItems} userMenu={userMenu} />
        </Toolbar>
      </Container>
    </Box>
  );
}
